import { disableBodyScroll, enableBodyScroll } from '~/js/utilities/dom';

const desktopNavBackdrop = () => ({
  active: false,

  handleOpenDesktopNav() {
    this.active = true;
    disableBodyScroll();
  },

  handleCloseDesktopNav() {
    this.active = false;
    enableBodyScroll();
  },
});

export default desktopNavBackdrop;
